import React from "react";
import styles from "./NeuralInterfaceNavigation.module.css";
import { NeuralInterfaceNavigationTabs } from "./NeuralInterfaceNavigationTabs";
import { NeuralInterfaceNavigationActions } from "./NeuralInterfaceNavigationActions";
function NeuralInterfaceNavigation({ containerId }) {
    return (React.createElement("div", { className: styles.navigation },
        React.createElement(NeuralInterfaceNavigationTabs, { className: styles.action, containerId: containerId }),
        React.createElement(NeuralInterfaceNavigationActions, { className: styles.actions })));
}
export default NeuralInterfaceNavigation;
